module.exports = __webpack_public_path__ + "static/media/mainimg-07.8d5890b7.png";